module.exports = __webpack_public_path__ + "static/media/dialog.7daca567.png";